(()=>{
  'use strict';
  const C=window.ShaoulianLocatorCore;
  if(!C)return;
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const t=JSON.parse(root.querySelector('[data-locator-strings]').textContent);
    const form=root.querySelector('[data-locator-form]'),input=root.querySelector('[data-locator-address]'),suggestions=root.querySelector('[data-locator-suggestions]');
    const status=root.querySelector('[data-locator-status]'),results=root.querySelector('[data-locator-results]'),map=root.querySelector('[data-locator-map]'),submit=form.querySelector('[type=submit]');
    const browse=root.querySelector('[data-store-filter]'),browseStatus=root.querySelector('[data-store-count]'),browseEmpty=root.querySelector('[data-store-empty]');
    const tabs=[...root.querySelectorAll('.tab-link')],panels=[...root.querySelectorAll('.tab-content')];
    const stores=[];
    panels.forEach(panel=>{
      panel.querySelectorAll('tbody tr').forEach(row=>{
        const cells=[...row.querySelectorAll('td')];
        const labels=[...panel.querySelectorAll('thead th')].map(th=>th.textContent.trim());
        cells.forEach((cell,index)=>cell.dataset.label=labels[index]||'');
        if(cells.length!==3)return;
        const store={name:cells[0].textContent.trim(),address:cells[1].textContent.trim(),phone:cells[2].textContent.trim(),region:panel.id,row};
        if(store.address==='nan')cells[1].textContent='—';
        store.search=C.normalize(store.name+' '+store.address+' '+store.region);
        stores.push(store);
      });
    });
    let activeRegion='all',selection=null,timer=null,suggestController=null,searchController=null,revision=0,options=[],activeOption=-1;
    const memory=new Map(),cachePrefix='shaoulian-store-geo-v1:';
    const office={name:t.showroom_name,address:t.showroom_address,geoAddress:'הירקון 5 בני ברק',phone:'09-7409835'};
    function message(text,error=false){status.textContent=text;status.classList.toggle('is-error',error);status.hidden=!text;}
    function busy(value){submit.disabled=value;submit.textContent=value?t.searching:t.submit;form.setAttribute('aria-busy',String(value));}
    function closeSuggestions(){suggestions.replaceChildren();suggestions.hidden=true;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');options=[];activeOption=-1;}
    function choose(index){const chosen=options[index];if(!chosen)return;selection=chosen;input.value=chosen.text;closeSuggestions();input.focus();}
    function showSuggestions(items){
      closeSuggestions();
      options=items.filter(item=>item.text&&C.point(item.shape));
      options.forEach((item,index)=>{
        const button=document.createElement('button');button.type='button';button.id=input.id+'-option-'+index;button.setAttribute('role','option');button.setAttribute('aria-selected','false');button.textContent=item.text;
        button.addEventListener('click',()=>choose(index));suggestions.append(button);
      });
      suggestions.hidden=!options.length;input.setAttribute('aria-expanded',String(!!options.length));
    }
    async function request(query,limit,signal){
      const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),9000);
      const abort=()=>controller.abort();
      if(signal){if(signal.aborted){clearTimeout(timeout);throw new DOMException('Aborted','AbortError');}signal.addEventListener('abort',abort,{once:true});}
      try{
        const response=await fetch('https://www.govmap.gov.il/api/search-service/autocomplete',{method:'POST',credentials:'omit',mode:'cors',headers:{'Content-Type':'application/json'},body:JSON.stringify({searchText:query,language:'he',isAccurate:false,maxResults:limit}),signal:controller.signal});
        if(!response.ok)throw new Error('address-service');
        const body=await response.json();return Array.isArray(body.results)?body.results:[];
      }finally{clearTimeout(timeout);if(signal)signal.removeEventListener('abort',abort);}
    }
    function cacheKey(address){return cachePrefix+C.normalize(address);}
    function cached(address){
      const key=cacheKey(address);if(memory.has(key))return memory.get(key);
      try{const data=JSON.parse(localStorage.getItem(key));if(data&&Date.now()-data.saved<2592000000&&C.point(data.shape)){memory.set(key,data);return data;}}catch(_){}
      return null;
    }
    async function geocodeStore(store,signal){
      const lookup=store.geoAddress||store.address;
      const saved=cached(lookup);if(saved)return {store,point:C.point(saved.shape)};
      const query=lookup.replace(/ירושלים והסביבה/g,'ירושלים');
      const found=await request(query+' ישראל',3,signal),city=C.cityOf(store.address)||C.cityOf(store.name);
      const match=found.find(item=>C.point(item.shape)&&(!city||C.cityOf(item.text)===city));
      if(!match)return null;
      const data={shape:match.shape,saved:Date.now()};memory.set(cacheKey(lookup),data);
      try{localStorage.setItem(cacheKey(lookup),JSON.stringify(data));}catch(_){}
      return {store,point:C.point(match.shape)};
    }
    async function locatePool(list,signal){
      const output=[];let cursor=0,failures=0;
      async function worker(){
        while(cursor<list.length&&!signal.aborted&&failures<3){
          const store=list[cursor++];
          try{const result=await geocodeStore(store,signal);if(result)output.push(result);}
          catch(error){if(signal.aborted)return;failures++;}
        }
      }
      await Promise.all(Array.from({length:Math.min(6,list.length)},worker));
      if(failures>=3&&!output.length)throw new Error('address-service');
      return output;
    }
    function appendText(parent,tag,text,className){const el=document.createElement(tag);el.textContent=text;if(className)el.className=className;parent.append(el);return el;}
    function card(store,distance,index,showroom=false){
      const article=document.createElement('article');article.className='sp-locator-card'+(showroom?' is-showroom':'');
      appendText(article,'span',showroom?t.showroom_badge:index===0?t.nearby:t.alternative,'sp-locator-badge');
      appendText(article,'h3',store.name);appendText(article,'p',store.address,'sp-locator-address');
      if(Number.isFinite(distance))appendText(article,'p',t.distance.replace('[[distance]]',distance<10?distance.toFixed(1):Math.round(distance)),'sp-locator-distance');
      const actions=document.createElement('div');actions.className='sp-locator-actions';article.append(actions);
      const directions=appendText(actions,'a',t.directions);directions.href=C.directions(store.address);directions.target='_blank';directions.rel='noopener';directions.dataset.locatorAction='directions';
      const phone=C.telephone(store.phone);if(phone){const call=appendText(actions,'a',t.call);call.href='tel:'+phone;call.dataset.locatorAction='call';}
      if(showroom){const contact=appendText(actions,'a',t.contact);contact.href=root.dataset.contactUrl;}
      return article;
    }
    function render(rank,officeDistance,label){
      results.replaceChildren();rank.slice(0,2).forEach((item,index)=>results.append(card(item.store,item.distance,index)));
      results.append(card(office,officeDistance,2,true));results.hidden=false;
      root.querySelector('[data-locator-hint]').hidden=false;
      map.replaceChildren();if(rank[0]){
        const iframe=document.createElement('iframe');iframe.title=t.map_title;iframe.loading='lazy';iframe.referrerPolicy='no-referrer-when-downgrade';iframe.src='https://www.google.com/maps?q='+encodeURIComponent(rank[0].store.address+', ישראל')+'&output=embed';map.append(iframe);map.hidden=false;
      }
      message(t.found.replace('[[count]]',Math.min(2,rank.length)).replace('[[address]]',label));
      window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'store_locator_search',store_locator_results:Math.min(2,rank.length)});
    }
    function filterStores(){
      const query=C.normalize(browse.value),terms=query.split(' ').filter(Boolean);let count=0;
      stores.forEach(store=>{const match=(activeRegion==='all'||store.region===activeRegion)&&terms.every(term=>store.search.includes(term));store.row.hidden=!match;if(match)count++;});
      panels.forEach(panel=>{const visible=[...panel.querySelectorAll('tbody tr')].some(row=>!row.hidden);panel.hidden=!visible;panel.classList.toggle('active',visible);});
      tabs.forEach(button=>{const active=button.dataset.tab===activeRegion;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active));});
      browseStatus.textContent=t.browse_count.replace('[[count]]',count);browseEmpty.hidden=count>0;
    }
    tabs.forEach(button=>button.addEventListener('click',()=>{activeRegion=button.dataset.tab;filterStores();}));
    browse.addEventListener('input',filterStores);
    root.querySelector('[data-filter-clear]').addEventListener('click',()=>{browse.value='';activeRegion='all';filterStores();browse.focus();});
    input.addEventListener('input',()=>{
      selection=null;revision++;clearTimeout(timer);suggestController?.abort();searchController?.abort();busy(false);closeSuggestions();
      results.replaceChildren();results.hidden=true;map.replaceChildren();map.hidden=true;root.querySelector('[data-locator-hint]').hidden=true;message('');
      const query=input.value.trim();if(query.length<3)return;
      const token=revision;
      timer=setTimeout(async()=>{
        suggestController=new AbortController();
        try{const found=await request(query,5,suggestController.signal);if(token===revision)showSuggestions(found);}catch(_){}
      },300);
    });
    input.addEventListener('keydown',event=>{
      if(event.key==='Escape'){closeSuggestions();return;}
      if(!options.length)return;
      if(event.key==='ArrowDown'||event.key==='ArrowUp'){
        event.preventDefault();activeOption=(activeOption+(event.key==='ArrowDown'?1:-1)+options.length)%options.length;
        [...suggestions.children].forEach((button,index)=>button.setAttribute('aria-selected',String(index===activeOption)));input.setAttribute('aria-activedescendant',input.id+'-option-'+activeOption);
      }else if(event.key==='Enter'&&activeOption>=0){event.preventDefault();choose(activeOption);}
    });
    root.addEventListener('click',event=>{if(!event.target.closest('.sp-locator-inputwrap'))closeSuggestions();});
    root.querySelector('[data-locator-clear]').addEventListener('click',()=>{
      revision++;searchController?.abort();suggestController?.abort();clearTimeout(timer);selection=null;input.value='';closeSuggestions();results.replaceChildren();results.hidden=true;map.replaceChildren();map.hidden=true;root.querySelector('[data-locator-hint]').hidden=true;message('');busy(false);input.focus();
    });
    form.addEventListener('submit',async event=>{
      event.preventDefault();clearTimeout(timer);suggestController?.abort();
      const raw=input.value.trim();if(raw.length<3){message(t.enter_address,true);input.focus();return;}
      searchController?.abort();searchController=new AbortController();const controller=searchController,token=++revision;
      const timeout=setTimeout(()=>controller.abort(),30000);
      busy(true);message(t.resolving);results.replaceChildren();results.hidden=true;map.replaceChildren();map.hidden=true;root.querySelector('[data-locator-hint]').hidden=true;closeSuggestions();
      try{
        let chosen=selection;
        if(!chosen){
          const found=(await request(raw,5,controller.signal)).filter(item=>item.text&&C.point(item.shape));
          if(token!==revision)return;
          if(found.length!==1){showSuggestions(found);message(found.length?t.choose_address:t.address_missing,true);return;}
          chosen=found[0];selection=chosen;input.value=chosen.text;
        }
        const origin=C.point(chosen.shape);if(!origin)throw new Error('coordinates');
        const candidates=C.candidates(stores,chosen.text,origin);
        message(t.ranking);
        let located=await locatePool(candidates.local.length>=2?candidates.local:candidates.local.concat(candidates.regional),controller.signal);
        if(located.length<2&&!controller.signal.aborted&&candidates.local.length>=2)located=located.concat(await locatePool(candidates.regional,controller.signal));
        if(token!==revision)return;
        const seen=new Set();
        const rank=located.map(item=>({...item,distance:C.distance(origin,item.point)})).filter(item=>{const key=C.normalize(item.store.name+' '+item.store.address);if(!Number.isFinite(item.distance)||seen.has(key))return false;seen.add(key);return true;}).sort((a,b)=>a.distance-b.distance);
        if(!rank.length)throw new Error('stores');
        let officeDistance=NaN;try{const officePoint=await geocodeStore(office,controller.signal);if(officePoint)officeDistance=C.distance(origin,officePoint.point);}catch(_){}
        if(token!==revision)return;render(rank,officeDistance,chosen.text);
      }catch(error){if(token===revision)message(t.unavailable,true);}
      finally{clearTimeout(timeout);if(token===revision)busy(false);}
    });
    results.addEventListener('click',event=>{const action=event.target.closest('[data-locator-action]')?.dataset.locatorAction;if(action){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'store_locator_'+action+'_click'});}});
    filterStores();
  }
  document.querySelectorAll('[data-sp-store-locator]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sp-store-locator]').forEach(init));
})();
